<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Crear Usuarios</h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-form class="mt-3">
                        <v-row justify="end">
                            <v-tooltip right style="margin-bottom: 5px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        dense
                                        to="lista-usuario"
                                        :loading="isloading"
                                        :disabled="isloading"
                                        color="blue"
                                        class="mt-4 mx-3"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon class="white--text"
                                            >mdi-arrow-left-bold-outline</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Volver</span>
                            </v-tooltip>
                        </v-row>

                        <DatosPersonalesRRHH
                            v-model="usuario"
                        ></DatosPersonalesRRHH>

                        <v-row>
                            <v-col cols="12">
                                <router-link to="lista-usuario">
                                    <v-btn color="red" class="white--text" s>
                                        Cancelar
                                    </v-btn>
                                </router-link>
                                <template v-if="usuario.idRol == 5">
                                    <v-btn
                                        v-if="!usuario.id"
                                        @click="saveusuario"
                                        :disabled="isloading"
                                        color="success"
                                        class="white--text"
                                        >Guardar</v-btn
                                    >
                                </template>
                                <template v-else>
                                    <v-btn
                                        v-if="!usuario.id"
                                        @click="saveagente"
                                        :disabled="isloading"
                                        color="success"
                                        class="white--text"
                                        >Guardar</v-btn
                                    >
                                </template>
                                <v-btn
                                    v-if="usuario.id"
                                    @click="updateusuario"
                                    :disabled="isloading"
                                    color="success"
                                    class="white--text"
                                    >Actualizar</v-btn
                                >
                                <v-btn
                                    v-if="usuario.id"
                                    @click="dialog_delete = true"
                                    :disabled="isloading"
                                    color="red"
                                    class="white--text"
                                    >Eliminar</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-form>
                </v-col>
            </v-row>
        </v-card>
        <DeleteDialog
            v-model="dialog_delete"
            @delete="deleteusuario"
        ></DeleteDialog>
    </v-container>
</template>

<script>
import DeleteDialog from "../../../components/general/dialogs/DeleteDialog.vue";
import DatosPersonalesRRHH from "./DatosPersonalesRRHH.vue";
export default {
    data() {
        return {
            dialog_delete: false,
            menu: false,
            usuario: {
                id: null,
                email: "",
                idRol: -1,
            },
        };
    },
    watch: {
        usuario: {
            deep: true,
            handler() {
                //console.log(this.usuario);
            },
        },
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
    },
    created() {
        if (this.$route.query.id) {
            this.getusuario(this.$route.query.id);
        }
    },
    methods: {
        saveagente() {
            axios
                .post("api/save-agente", { usuario: this.usuario })
                .then((res) => {
                    this.$router.push("lista-usuario");
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.message);
                    } else {
                        this.$custom_error(error.response.data.message);
                    }
                });
        },
        getusuario(usuario_id) {
            axios.get(`api/getusuario/${usuario_id}`).then(
                (res) => {
                    this.usuario = res.data;
                },
                (res) => {}
            );
        },
        updateusuario() {
            axios
                .post("api/update-usuario", this.usuario)
                .then((res) => {
                    this.$router.push("lista-usuario");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salio mal");
                    }
                });
        },
        saveusuario() {
            axios
                .post("api/save-usuario", this.usuario)
                .then((res) => {
                    this.$router.push("lista-usuario");
                })
                .catch((error) => {
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salio mal");
                    }
                });
        },
        deleteusuario() {
            axios.post("api/delete-usuario", { id: this.usuario.id }).then(
                (res) => {
                    this.$router.push("lista-usuario");
                },
                (res) => {}
            );
        },
        save(date) {
            this.$refs.menu.save(date);
        },
    },
    filters: {},
    components: {
        DatosPersonalesRRHH,
        DeleteDialog,
    },
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        roles() {
            return this.$store.getters.getroles;
        },
    },
};
</script>
